import React, { useState } from 'react';
import styles from "./emptyaddress.module.css"
import ProfileMenu from '../../components/profilemenu/ProfileMenu';
import AddAddress from '../../components/shippingAddress/AddAddress';

const EmptyAddress = () => {
     const [isPopupVisible, setIsPopupVisible] = useState(false); // Popup hidden initially
    
        const handleClose = () => {
            setIsPopupVisible(false); // Close the popup when the user clicks on the close button
        };
    
        const handleSignupClick = () => {
            setIsPopupVisible(true);
        };
    return (
        <>
            <div className={styles.myprofile}>
                <div className={styles.promenu}>
                    <ProfileMenu />
                </div>
                <div className={styles.prodetailsContainer}>
                    <div className={styles.profileheader}>
                        <h2>Shipping Address</h2>
                        <button className={styles.editButton} onClick={handleSignupClick}>
                            Add new address
                        </button>
                    </div>
                    <div className={styles.profilebodyContent}>

                        <span>No shipping address are added yet!</span>

                    </div>
                </div>
            </div>


            {isPopupVisible && (
                <AddAddress onClose={handleClose} />
            )}

        </>
    );
};

export default EmptyAddress;
